document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector('.lc-site-header');
  const button = header && header.querySelector('.menu-button');
  const menuContainer = header && header.querySelector('#main-menu-container');
  if (!button || !menuContainer) return;

  const mainItems = menuContainer.querySelectorAll('[data-cm-main-item]');
  const subItems = menuContainer.querySelectorAll('[data-cm-sub-item]');
  const submenus = menuContainer.querySelectorAll('[data-cm-subnav]');
  const submenuColumn = menuContainer.querySelector('.cm-subnavs');
  const submenuTriggers = menuContainer.querySelectorAll('[data-cm-submenu-trigger], [data-cm-submenu-toggle]');
  const submenuToggles = menuContainer.querySelectorAll('[data-cm-submenu-toggle]');
  const previewImages = menuContainer.querySelectorAll('[data-cm-preview] img');
  const mobilePreviewImages = menuContainer.querySelectorAll('[data-cm-mobile-preview] img');
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const mobileMenu = window.matchMedia('(max-width: 720px)');
  let previewTimer;

  const positionSubmenus = () => {
    if (!submenuColumn) return;
    submenus.forEach((submenu) => {
      const mainItem = Array.from(mainItems).find((item) => item.getAttribute('aria-controls') === submenu.id);
      const parentItem = mainItem && mainItem.closest('li');
      const target = mobileMenu.matches && parentItem ? parentItem : submenuColumn;
      target.appendChild(submenu);
    });
  };

  positionSubmenus();
  mobileMenu.addEventListener('change', positionSubmenus);

  const showPreview = (item) => {
    const key = item.dataset.previewKey;
    const nextPreview = Array.from(previewImages).find((image) => image.dataset.previewKey === key);

    if (nextPreview && !nextPreview.classList.contains('is-shown')) {
      window.clearTimeout(previewTimer);

      previewImages.forEach((image) => {
        if (image.classList.contains('is-shown')) {
          image.classList.add('is-holding');
          image.classList.remove('is-shown');
        }
      });

      nextPreview.classList.remove('is-holding');
      nextPreview.classList.add('is-shown');

      previewTimer = window.setTimeout(() => {
        previewImages.forEach((image) => image.classList.remove('is-holding'));
      }, 400);
    }

    mobilePreviewImages.forEach((image) => {
      image.classList.toggle('is-shown', image.dataset.previewKey === key);
    });
  };

  const activateMainItem = (item, openSubmenu = true) => {
    mainItems.forEach((mainItem) => mainItem.removeAttribute('data-active'));
    item.setAttribute('data-active', 'true');
    showPreview(item);

    const submenuId = openSubmenu && item.hasAttribute('data-cm-submenu-trigger') ? item.getAttribute('aria-controls') : null;
    submenus.forEach((submenu) => {
      const isOpen = submenu.id === submenuId;
      submenu.classList.toggle('is-open', isOpen);
      submenu.setAttribute('aria-hidden', String(!isOpen));
      submenu.toggleAttribute('inert', !isOpen);
    });
    submenuTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(trigger.getAttribute('aria-controls') === submenuId)));
    subItems.forEach((subItem) => subItem.removeAttribute('data-active'));
  };

  mainItems.forEach((item) => {
    if (canHover) item.addEventListener('mouseenter', () => activateMainItem(item));
    item.addEventListener('focus', () => activateMainItem(item));

    if (item.hasAttribute('data-cm-submenu-trigger')) {
      item.addEventListener('click', (event) => {
        if (item.tagName !== 'A' || item.getAttribute('href') === '#') event.preventDefault();
        activateMainItem(item);
      });
    }
  });

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const mainItem = Array.from(mainItems).find((item) => item.getAttribute('aria-controls') === toggle.getAttribute('aria-controls'));
      if (mainItem) activateMainItem(mainItem, toggle.getAttribute('aria-expanded') !== 'true');
    });
  });

  subItems.forEach((item) => {
    const activateSubItem = () => {
      subItems.forEach((subItem) => subItem.removeAttribute('data-active'));
      item.setAttribute('data-active', 'true');
      showPreview(item);
    };

    if (canHover) item.addEventListener('pointerenter', activateSubItem);
    item.addEventListener('focus', activateSubItem);
  });

  if (mainItems.length) activateMainItem(mainItems[0]);

  const setMenuOpen = (isOpen) => {
    header.classList.toggle('main-menu-active', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
    menuContainer.setAttribute('aria-hidden', String(!isOpen));
    menuContainer.toggleAttribute('inert', !isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  };

  menuContainer.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[data-cm-main-item], a[data-cm-sub-item]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.search === window.location.search) {
      setMenuOpen(false);
    }
  });

  button.addEventListener('click', function() {
    const isOpen = !header.classList.contains('main-menu-active');
    setMenuOpen(isOpen);
    if (isOpen) {
      window.scrollTo(0, 0);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && header.classList.contains('main-menu-active')) {
      setMenuOpen(false);
      button.focus();
    }
  });
});
